<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="课程名称：">
            <el-input v-model="query.name" placeholder="请输入课程名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="课程分类：" v-if="sourceType === 2">
            <el-cascader v-model="categorizeIdArr" :props="categorizepProps" :options="courseClassOptions" size="small" clearable></el-cascader>

          </el-form-item>


          <el-form-item label="福利类型：" v-if="sourceType === 1">
            <el-select v-model="query.welfareId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in welfareOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="讲师：">
            <el-select v-model="query.lecturerId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in lecturerOptions" :key="index" :label="item.realName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否收费：" v-if="sourceType === 2">
            <el-select v-model="query.isFreeAmount" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否配置考试：" v-if="sourceType === 2">
            <el-select v-model="query.isExam" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-select v-model="timeType" placeholder="请选择" clearable size="small">
              <el-option label="创建时间" :value="1"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="appDisplayTab" @tab-click="handleAppDisplayTabClick">
          <el-tab-pane label="推荐课程" name="recommend"></el-tab-pane>
          <el-tab-pane label="课程" name="course"></el-tab-pane>
          <el-tab-pane label="业务物料" name="template"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="sourceType === 2" style="margin-left: 20px;">
          <el-tab-pane label="全部" name="1"></el-tab-pane>
          <el-tab-pane label="推荐课程" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['course:course:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['course:course:state']">批量禁用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,3)" v-if="sourceType === 2" v-hasPermi="['course:course:recommend']">设为推荐</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,4)" v-if="sourceType === 2" v-hasPermi="['course:course:recommend']">取消推荐</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['course:course:add']">新增课程</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="课程名称" prop="name" align="center" width="200" fixed>
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row,2)">{{row.name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="福利类型" prop="welfareName" align="center" v-if="sourceType === 1" />
        <el-table-column label="课程分类" prop="className" align="center" width="200" v-if="sourceType === 2" />
        <el-table-column label="APP展示" prop="appDisplay" align="center">
          <template slot-scope="{row}">

          </template>
        </el-table-column>
        
        <el-table-column label="封面图" prop="coverImage" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.coverImage" :preview-src-list="[row.coverImage]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="讲师" prop="realName" align="center">
          <template slot-scope="{row}">
            <el-link v-if="row.type === 2" type="primary" @click="handleShow(row,6)">{{row.realName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="章节节数" prop="chapterNum" align="center" />
        <template v-if="sourceType === 2">
          <el-table-column label="收费金额(元)" prop="feeAmount" align="center" />
          <el-table-column label="学分查看标准" prop="lookCredits" align="center" />
          
        </template>
        <el-table-column label="页面排序" prop="orderNo" align="center" />
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" v-hasPermi="['course:course:state']"></el-switch>
            {{row.state?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['course:course:edit']">编辑</el-button>
            <el-button type="text" @click="handleRecommend(row.id,row.isRecommend?0:1)" v-if="sourceType === 2 &&appDisplayTab!='template'" v-hasPermi="['course:course:recommend']">{{row.isRecommend?'取消推荐':'设为推荐'}}</el-button>
            <el-button type="text" v-if="row.type === 1 && sourceType === 1" @click="handleLog(row)">日志记录</el-button>

            <el-dropdown @command="handleCommand1" v-if="sourceType === 2 || (row.type === 2 &&  sourceType === 1)">
              <el-button type="text">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand1(row,1)" v-if="row.type === 2" v-hasPermi="['course:course:repair']">修复方案</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,2)" v-if="row.type === 2" v-hasPermi="['course:course:chapter']">章节</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,3)" v-if="row.type === 2" v-hasPermi="['course:course:courseware']">课件</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,4)" v-if="sourceType === 2" v-hasPermi="['course:course:learn']">学习权限</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,5)" v-if="sourceType === 2" v-hasPermi="['course:course:exam']">考试配置</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,6)">日志记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <course-add ref="courseAdd" @created="doQueryList({})" :welfareOptions="welfareOptions" :courseClassOptions="courseClassOptions" :lecturerOptions="lecturerOptions" :sourceType="sourceType" />
    <course-list-jurisd ref="courseListJurisd" />
    <course-list-exam ref="courseListExam" />
  </div>
</template>

<script>
import courseAdd from './add.vue'
import courseSubjectApi from '@/api/course/courseSubject'
import Pagination from '@/components/Pagination'
import courseClassificationApi from '@/api/course/courseClassification'
import lecturerApi from '@/api/course/lecturer'
import courseListJurisd from './listJurisd.vue'
import courseListExam from './listExam.vue'
import courseWelfareClassificationApi from '@/api/course/courseWelfareClassification'
export default {
  //sourceType  1新人福利 2课程管理
  props: ['sourceType'],
  components: {
    Pagination,
    courseAdd,
    courseListJurisd,
    courseListExam
  },
  data() {
    return {
      categorizepProps: {
        label: 'typeName',
        value: 'id',
        children: 'classificationChildList',
        checkStrictly: true,
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        isFreeAmount: -1,
        name: undefined,
        welfareId: undefined,
        lecturerId: undefined,
        state: undefined,
        isExam: undefined,
      },
      categorizeIdArr: [],
      selectItems: [],
      courseClassOptions: [],
      lecturerOptions: [],
      timeType: null,
      dateTime: [],
      activeName: '1',
      appDisplayTab: 'course',
      welfareOptions: [],
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    courseClassificationApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1, categoryId: 2 }).then(({ data }) => {
      this.courseClassOptions = this.formatCascaderData(data.list)
      console.log(this.courseClassOptions)
    })
    lecturerApi.fetchList({ pageNo: 1, pageSize: 1000, isEnable: true }).then(({ data }) => { this.lecturerOptions = data.list })
    this.getWelfareClass()
  },
  methods: {
    getWelfareClass() {
      courseWelfareClassificationApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(({ data }) => {
        this.welfareOptions = data.list
      })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    handleAppDisplayTabClick() {
      this.doQueryList({ pageNo: 1 })
    },
    handleFilter() {
      this.query = {}
      this.timeType = ''
      this.dateTime = []
      this.categorizeIdArr = [];
      this.appDisplayTab = 'course'
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (!data[i].classificationChildList) return
        if (data[i].classificationChildList.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].classificationChildList = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].classificationChildList)
        }
      }
      return data
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    calcQuery() {
      this.query.createdTimeStart = undefined
      this.query.createdTimeEnd = undefined
      this.query.operatedTimeStart = undefined
      this.query.operatedTimeEnd = undefined
      if (this.dateTime.length > 0) {
        if (this.timeType === 1) {
          this.query.createdTimeStart = this.dateTime[0]
          this.query.createdTimeEnd = this.dateTime[1]
        } else if (this.timeType === 2) {
          this.query.operatedTimeStart = this.dateTime[0]
          this.query.operatedTimeEnd = this.dateTime[1]
        }
      }
      // APP展示筛选
      if (this.appDisplayTab === 'recommend') {
        // 推荐课程：isRecommend = 1, viewCourse = 1
        this.query.viewCourse = 1
        this.query.isRecommend = 1
        this.query.viewTemplate = undefined
      } else if (this.appDisplayTab === 'course') {
        // 课程：isRecommend = 0, viewCourse = 1
        this.query.viewCourse = 1
        this.query.isRecommend = 0
        this.query.viewTemplate = undefined
      } else if (this.appDisplayTab === 'template') {
        // 业务物料：viewTemplate = 1
        this.query.viewTemplate = 1
        this.query.viewCourse = undefined
        this.query.isRecommend = undefined
      }
      // 原有的推荐课程筛选逻辑（仅在sourceType === 2时，且APP展示tab未设置isRecommend时生效）
      if (this.sourceType === 2) {
        // 如果APP展示tab已经设置了isRecommend，则不再使用activeName的逻辑
        if (this.appDisplayTab !== 'recommend' && this.appDisplayTab !== 'course') {
          this.query.isRecommend = this.activeName === '2' ? 1 : undefined
        }
      } else {
        this.query.isFreeAmount = -1
        this.query.isExam = undefined
      }
      this.query.classificationIdList = this.categorizeIdArr.length > 0 ? this.categorizeIdArr[this.categorizeIdArr.length - 1] : undefined
      this.query.sourceType = this.sourceType
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.listLoading = true
      return courseSubjectApi.fetchList(this.query)
        .then(data => {
          let { list, total } = data.data;
          list.forEach(item => {
            let arr = []
            item.courseClassificationVOList.forEach(itt => {
              arr.push(itt.typeName + (itt.courseClassificationVO ? '>' + itt.courseClassificationVO.typeName : '') +
                (itt.courseClassificationVO && itt.courseClassificationVO.courseClassificationVO ? '>' + itt.courseClassificationVO.courseClassificationVO.typeName : ''))
            })
            item.className = arr.toString()
          });
          this.list = list;
          this.total = total;
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      } else if (command.command === 3) {
        this.handleRecommend(ids, 1)
      } else if (command.command === 4) {
        this.handleRecommend(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '是否批量启用？' : '是否批量禁用？'
      this.$common.confirm(txt).then(() => courseSubjectApi.batchState({ idList: ids, state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleRecommend(ids, type) {
      let txt = type ? '是否设为推荐？' : '是否取消推荐？'
      this.$common.confirm(txt).then(() => courseSubjectApi.batchRecommend({ id: ids, recommend: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand1(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand1(command) {
      // 修复方案
      if (command.command === 1) {
        this.$emit('handleShow', command.row, 3)
      } else if (command.command === 2) { //章节
        this.$emit('handleShow', command.row, 4)
      } else if (command.command === 3) {  //课件
        this.$emit('handleShow', command.row, 5)
      } else if (command.command === 4) {  //学习权限
        this.$refs.courseListJurisd.handleCreate(command.row)
      } else if (command.command === 5) {  //考试配置
        this.$refs.courseListExam.handleCreate(command.row)
      } else if (command.command === 6) {  //日志记录
        this.$router.push("/log/log?type=4&id=" + command.row.id);
      }
    },
    handleLog(row) {
      this.$router.push("/log/log?type=4&id=" + row.id);
    },
    changeSwitch(row) {
      courseSubjectApi.batchState({ idList: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.courseAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type, this.sourceType)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.courseAdd.handleUpdate(row)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }
}
</style>
